// https://docs.amplify.aws/gen1/javascript/tools/libraries/configure-categories/#authentication-amazon-cognito
// https://watilde.medium.com/how-to-use-a-custom-domain-of-cognito-hosted-ui-with-amplify-de6b772281ba
// https://github.com/aws-amplify/amplify-cli/issues/2792
import { Amplify } from 'aws-amplify';
import awsconfig from '../amplifyconfiguration.json';

// NOTE phil: this is a workaround for the issue with custom domains in aws-exports.js
// removing the part of the domain that is causing it not to work
if (awsconfig.oauth.domain.includes('.auth.us-east-1.amazoncognito.com')) {
  awsconfig.oauth.domain = awsconfig.oauth.domain.replace('.auth.us-east-1.amazoncognito.com', '')
}

// @ts-ignore
Amplify.configure(awsconfig);
